import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { filter, Subject, takeUntil } from 'rxjs';
import Icons from 'src/app/core/enums/icons.enum';
import { AuthService } from 'src/app/core/services/auth.service';
import { PortalStateService } from 'src/app/core/services/portal-state.service';
import { ToolbarService } from 'src/app/core/services/toolbar.service';
import { UserService } from 'src/app/core/services/user.service';
import { MenuItem } from 'src/portaljs/models/menu-item';

@Component({
  selector: 'fss-portal-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
  standalone: false
})
export class MobileMenuComponent implements OnInit, OnDestroy {
  public isGuest = true;
  public isShared = true;
  private sitesAvailable = 0;
  private districtUserType = false;

  public get isMobile(): boolean {
    return this.toolbarService.isMobile();
  }

  public get menuItems(): MenuItem[] {
    return this.portalStateService.activeMenuItems;
  }

  @ViewChildren(MatExpansionPanel)
  public accordion: QueryList<MatExpansionPanel>;

  public icons = Icons;

  public get showSiteNotifications(): boolean {
    return !this.isShared;
  }

  public getIsDestinyViewSelectorEnabled(): boolean {
    return this.portalStateService.getIsDestinyViewSelectorEnabled();
  }

  private readonly ngUnsubscribe = new Subject<void>();

  constructor(
    private readonly authService: AuthService,
    private readonly portalStateService: PortalStateService,
    private readonly toolbarService: ToolbarService,
    private readonly userService: UserService
  ) {}

  public ngOnInit(): void {
    this.authService.getUserLogin$()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((ulm) => {
        this.isGuest = ulm?.isGuestUser() ?? true;
        this.isShared = ulm?.isSharedUser() ?? true;
        this.districtUserType = ulm && (ulm.isDistrictUser() || ulm.isDestinyAdmin());
      });

    this.userService.getEnrolledSitesInDistrict$()
      .pipe(
        filter((x) => !!x),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((rez) => (this.sitesAvailable = rez.length));
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public closeAccordion(): void {
    this.accordion.forEach((matExpansion) => matExpansion.close());
  }

  public login(): void {
    this.toolbarService.login();
  }

  public menuSelected(menuItem: MenuItem) {
    this.toolbarService.menuSelected(menuItem);
  }

  public closeMobileMenu() {
    this.toolbarService.isMobileMenuOpen = false;
    this.closeAccordion();
  }

  public showSiteSwitcher() {
    if (this.authService.isDestinyForcePasswordReset()) {
      return false;
    } else {
      return this.districtUserType ? (this.sitesAvailable > 0) : (this.sitesAvailable > 1);   
    }
  }
}
